export enum TimeUnit {
  NONE = 0,
  DAYS = 1,
  MINUTES = 2,
}
